import { render, staticRenderFns } from "./ScopeInput.vue?vue&type=template&id=f1aba730&scoped=true&"
import script from "./ScopeInput.vue?vue&type=script&lang=js&"
export * from "./ScopeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1aba730",
  null
  
)

export default component.exports